export default class SpecimensModel{
    setNO: number[] | undefined
    batchNO: string[] | undefined
    massInBatch: number[] | undefined
    nominalSize: number[] | undefined
    grade: string[] | undefined
    barPattern: string[] | undefined
    class: string[] | undefined
    customerSampleIdentityNO: string[] | undefined
    numberOfTestSpecimenTensile: number[] | undefined
    numberOfTestSpecimenBendPerformance: number[] | undefined
    numberOfTestSpecimenBondProperty: number[] | undefined
    numberOfTestSpecimenChemicalComposition: number[] | undefined
    id: string[] | undefined
    customer: string[] | undefined
}